import styled, { css } from 'styled-components';
import Button from 'components/Button';

export const PortfolioContainer = styled.div`
    z-index: 1;
    width: 100vw;
    padding-bottom: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #D6E1EF;
    @media only screen and (max-width: 768px) {
        padding-bottom: 25px;
    }
`;

export const LaunchImageImage = styled.img`
    max-width: 100%;
`;

export const Title = styled.h1`
    font-family: Khula;
    font-style: normal;
    font-weight: 800;
    font-size: 35px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const Description = styled.h3`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    color: #D6E1EF;
    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        color: #D6E1EF;
    }
`;

export const CallToAction = styled(Button)`
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
    }
`;

export const ContainerListDesktop = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

export const ContainerListPhone = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    @media only screen and (min-width: 768px) {
        display: none;
    }
`;




export const InputsContainer = styled.form`
    margin: 10px 0px;
    width: 101%;
    border-radius: 17px;
`;

export const Input = styled.input`
    color: white;
    margin-bottom: 10px;
    width: 100%;
    height: 56px;
    background: linear-gradient(344.2deg, #2C333A -71.57%, #1C1E22 59.28%, #121416 59.28%);
    box-shadow: inset 2px 3px 10px #070709, inset -2px -2px 10px rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    padding: 10px;
    font-family: 'Khula', sans-serif;
    outline: 0;
    border: none;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    color: #D6E1EF;
    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        font-size: 20px;
        line-height: 100%;
    }
`;

export const ModalTitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const ModalContent = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 20px;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        color: #D6E1EF;
    }
`;